<div class="PGResourceViewCalendar">
    <div class="PGResourceViewCalendar-Actions">
        @if (actions.create) {
            <button class="btn btn-sm btn-primary" (click)="createNew()">
                <i class="fa-regular fa-plus"></i><span>{{ 'pg-resource-view-calendar.add-resource' | locTranslate:'resource':resourceName }}</span>
            </button>
        }
    </div>
    <app-pg-calendar-resource [resourceId]="resourceId" [relatedResource]="relatedResource" [relatedElement]="relatedElement" [dateField]="dateField" [dataFilter]="dataFilter"></app-pg-calendar-resource>
</div>
